import { hbs } from 'ember-cli-htmlbars';
export default hbs("<span\n  class=\"site-audit-status-badge {{this.responseCodeType}}\"\n>{{@responseCode}}</span>")